<template>
  <div>
    <i
      v-if="connected"
      class="fas fa-bolt text-green-500"
    />
    <i
      v-else-if="connecting"
      class="fas fa-bolt text-yellow-500"
    />
    <i
      v-else-if="unavailable"
      class="fas fa-bolt text-red-500"
    />

    <ConnectionIssuesModal
      v-show="!initializing && notification"
      :connecting="connecting"
      :unavailable="unavailable"
      :reinitialized="reinitialized"
    />
  </div>
</template>

<script>
import ConnectionIssuesModal from '../Modals/ConnectionIssuesModal';
export default {
  components: {ConnectionIssuesModal},
  data () {
    return {
      initializing: true,
      reinitialized: false,
      connected: false,
      connecting: false,
      unavailable: false,
      notification: false,
    };
  },

  mounted () {
    this.handleState(this.$echo.connector.pusher.connection.state);
    this.$echo.connector.pusher.connection.bind(
        'state_change',
        (event) => this.handleState(event.current),
    );
  },

  methods: {
    handleState(status) {
      if (this.reinitialized) {
        return;
      }

      if (status === 'connected') {
        this.connected = true;

        if (this.initializing) {
          this.connecting = false;
          this.unavailable = false;
          this.notification = false;
          this.initializing = false;
        } else if (this.connecting || this.unavailable) {
          this.reinitialized = true;

          setTimeout(() => window.location.reload(), 4000);
        }
      } else if (status === 'connecting') {
        this.connected = false;
        this.connecting = true;
        this.unavailable = false;
        this.notification = true;
      } else if (status === 'unavailable') {
        this.connected = false;
        this.connecting = false;
        this.unavailable = true;
        this.notification = true;
      }
    },
  },
};
</script>
